import { useCallback, useContext } from 'react';

import { Button } from 'antd';

import { FormGroupContext } from '@/components/FormGroup';
import Files from '@/components/wizard/Files';
import { validateFields } from '@/lib/validation';
import { aiSteps, productDetailsWithoutIaSteps } from '@/pages/CreateProduct/steps';
import useProductStore from '@/stores/productStore';
import { stepStore } from '@/stores/steps';

import Wizard from '../..';

const Details = () => {
  const { emit } = useContext(FormGroupContext);
  const deliverable = useProductStore(d => d.deliverables);

  const submit = useCallback(async () => {
    const results = await emit({ type: 'validate' });
    const allValid = validateFields(results);

    if (allValid) {
      stepStore.getState().addSteps({ steps: aiSteps, removeStepsOnReturn: true });
      stepStore.getState().nextStep();
    }
  }, [emit]);

  const continueWithoutFiles = useCallback(() => {
    stepStore.getState().addSteps({ steps: productDetailsWithoutIaSteps, removeStepsOnReturn: true });
    stepStore.getState().nextStep();
  }, []);

  return (
    <div className='mt-4 mb-28 flex flex-col gap-4'>
      <Files />

      <Wizard.Footer>
        <Button type='primary' id='submit' onClick={submit}>
          Continuar
        </Button>

        <Button
          type='default'
          id='continue-without-files-button'
          onClick={continueWithoutFiles}
          disabled={deliverable.length >= 1}
        >
          Continuar e fazer o upload depois
        </Button>
      </Wizard.Footer>
    </div>
  );
};
export default Details;
